module.exports = __webpack_public_path__ + "Simple-Line-Icons.6ac7320f709ffd2784b4.woff2";


//////////////////
// WEBPACK FOOTER
// /Users/andrescufari/Angular/lednube/theme/scss/icons/simple-line-icons/fonts/Simple-Line-Icons.woff2?-i3a2kk
// module id = ../../../../../theme/scss/icons/simple-line-icons/fonts/Simple-Line-Icons.woff2?-i3a2kk
// module chunks = styles